export default {"src":"/_next/static/media/facebook.94407f55.svg","height":24,"width":24};